import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CubeDetailDialogComponent } from './cube-detail-dialog.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { MaterialModule } from 'app/main/material.module';

@NgModule({
  declarations: [CubeDetailDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    AgGridModule.withComponents([]),
  ],
  entryComponents: [CubeDetailDialogComponent],
  exports: [CubeDetailDialogComponent]
})
export class CubeDetailModule { }
